import { useMutation, useQueryClient } from 'react-query';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { deletePlannerTask } from 'RestAPIs/planner-messages';

const useDeletePlannerTask = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    (processInstanceId: string) => deletePlannerTask(processInstanceId),
    {
      onSuccess: () => {
        showSuccessSnackbar();
        queryClient.invalidateQueries('plannerTasks');
        queryClient.invalidateQueries('plannerTaskTabCounts');
      },
      onError: () => showErrorSnackbar()
    }
  );

  return { mutateAsync, isLoading };
};

export default useDeletePlannerTask;
